import axios from "axios";

const ENDPOINT_KEY = "supplier";
const ENDPOINT_URI = "/supplier";

export default function useSupplierService() {
  return {
    queryKey: ENDPOINT_KEY,
    getAllSuppliers: async (search = "", page = 1, limit = 10) => {
      const params = new URLSearchParams({
        page,
        limit,
      });
      if (search) {
        params.append("search", search);
      }
      const response = await axios.get(`${ENDPOINT_URI}/`, { params });
      return response.data.payload;
    },
    getSupplierById: async (id) => {
      const response = await axios.get(`${ENDPOINT_URI}/${id}`);
      return response.data.payload;
    },
    addSupplier: async ({ payload }) => {
      const response = await axios.post(`${ENDPOINT_URI}/`, payload);
      return response.data.payload;
    },
    updateSupplier: async ({ id, payload }) => {
      const response = await axios.put(`${ENDPOINT_URI}/${id}`, payload);
      return response.data.payload;
    },
    addNewBankDetails: async ({ id, payload }) => {
      const response = await axios.post(
        `${ENDPOINT_URI}/${id}/bank-details`,
        payload
      );
      return response.data.payload;
    },
    updateExistingBankDetails: async ({ id, payload, bankDetailId }) => {
      const response = await axios.put(
        `${ENDPOINT_URI}/${id}/bank-details/${bankDetailId}`,
        payload
      );
      return response.data.payload;
    },
    deleteBankDetails: async ({ id, bankDetailId }) => {
      const response = await axios.delete(
        `${ENDPOINT_URI}/${id}/bank-details/${bankDetailId}`
      );
      return response.data.payload;
    },
  };
}
